<template>
  <div>
    <v-container>
      <generalAlert
        v-if="alert"
        :alert="alert"
        :alertType="alertType"
        :message="successResponse"
      />
      <v-row
        v-if="
          (!this.currentUser.facebookToken &&
            !this.$store.state.loggedIntoFacebook) ||
          (this.currentUser.facebookToken &&
            !this.$store.state.loggedIntoFacebook)
        "
      >
        <v-col cols="12" class="text-center">
          <h2 class="compeatfont">Welcome to Compeat</h2>
          <p>Please sign in to Facebook</p>
          <v-btn
            small
            rounded
            @click="loginWithFacebook()"
            class="primary"
            :loading="facebookLoginLoading"
          >
            <v-icon>mdi-facebook</v-icon> Login To Facebook
          </v-btn>
          <p v-if="cancelledLogin">
            Client Cancelled Signin. please try again.
          </p>
        </v-col>
      </v-row>
      <v-row
        v-if="
          this.currentUser.facebookToken && this.$store.state.loggedIntoFacebook
        "
      >
        <v-col cols="12">
          <h2>Welcome {{ this.$store.state.user.name }}</h2>
        </v-col>
        <v-col
          cols="12"
          class="text-center"
          v-if="!this.$store.state.user.resellerUid"
        >
          <v-img
            src="../../assets/createReseller.png"
            width="300px"
            class="mx-auto"
          />
          <h3>
            Before you can start please can you create a Reseller Profile.
          </h3>
          <p>Please click below.</p>
          <v-btn small rounded class="primary" @click="createResellerProfile()">
            Create Profile
          </v-btn>
        </v-col>
        <v-col
          v-if="
            this.$store.state.user.resellerUid &&
            !this.$store.state.resellerAccount.stripeAccountId
          "
          cols="12"
          class="text-center"
        >
          <v-img src="../../assets/Signup.png" width="300px" class="mx-auto" />
          <h3>
            Now we need to create a accounted stripe account. This is for
            payouts to your bank account.
          </h3>
          <p>Please click below.</p>
          <v-btn
            small
            rounded
            class="primary"
            @click="createResellerConnectedAccount()"
          >
            Create Connected Account
          </v-btn>
        </v-col>
        <v-col
          v-if="
            this.$store.state.user.resellerUid &&
            this.$store.state.resellerAccount.stripeAccountId
          "
          cols="12"
          class="py-0"
        >
          <v-row>
            <v-col class="col-12 col-sm-12 col-mb-4 col-lg-4">
              <v-card
                v-if="!overlay"
                color="primary"
                dark
                flat
                class="px-3 py-3"
                @click="viewActiveSubscription()"
              >
                <v-row>
                  <v-col class="col-12 danetest--text compeatfont">
                    Active Subscriptions
                  </v-col>
                  <v-col class="col-3">
                    <v-icon class="danetest--text" large
                      >mdi-account-multiple</v-icon
                    >
                  </v-col>
                  <v-col class="col-9 text-right danetest--text">
                    <h1>{{ resellerActiveSubscriptions.length }}</h1>
                  </v-col>
                </v-row>
              </v-card>
              <v-skeleton-loader
                v-else
                height="120px"
                class="mx-auto"
                type="image"
              >
              </v-skeleton-loader>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { firebaseApp } from "../../firebaseConfig";
import {
  getFirestore,
  doc,
  getDoc,
  query,
  setDoc,
  collection,
  where,
  getDocs,
  updateDoc,
} from "firebase/firestore";
import { getFunctions, httpsCallable } from "firebase/functions";
import generalAlert from "../alerts/generalAlert.vue";

const db = getFirestore(firebaseApp);

export default {
  props: ["uid", "user", "getcurrentuser"],
  components: {
    generalAlert,
  },
  data: () => ({
    //Boolean Values
    overlay: false,
    cancelledLogin: false,
    facebookLoginLoading: false,

    //user Info
    userToken: "",
    currentUser: {},

    //reseller Varibles
    resellerAccount: {},
    resellerActiveSubscriptions: [],

    // Initially show col-4 - col-8 is not expanded
    showCol4: true,
    expandCol8: false,

    // mobile stats
    showStats: false,

    //table Varible
    search: "",
    tableLoading: false,
    headers: [
      { text: "Client", value: "name", sortable: false, align: "center" },
      {
        text: "Company",
        sortable: false,
        value: "package.primaryPage.name",
        align: "center",
      },
      { text: "Package", sortable: false, value: "package", align: "center" },
      {
        text: "Date Created",
        value: "dateCreated",
        sortable: true,
        align: "center",
      },
      { text: "Status", value: "isActive", sortable: false, align: "center" },
      { text: "Action", value: "action", sortable: false, align: "center" },
    ],
    //Alert for new subscription
    successResponse: "",
    alertType: "",
    alert: false,
  }),
  //facebook SDK
  mounted() {
    (function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s);
      js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");

    window.fbAsyncInit = function () {
      FB.init({
        appId: "736605293879783",
        autoLogAppEvents: true,
        xfbml: true,
        version: "v16.0",
      });
    };
  },
  //Created Hook - gets the user and checks for facebook userToken
  created() {
    this.overlay = true;
    this.currentUser = this.$store.state.user;
    if (this.currentUser.facebookToken) {
      this.checkTokenValid(this.currentUser.facebookToken);
    } else {
      this.overlay = false;
    }
  },
  methods: {
    //Validates the user token
    checkTokenValid(token) {
      this.facebookLoginLoading = true;
      const functions = getFunctions(firebaseApp, "europe-west2");
      const checkIfTokenIsValid = httpsCallable(
        functions,
        "checkIfTokenIsValid"
      );
      checkIfTokenIsValid({
        token: token,
      })
        .then((result) => {
          if (result.data.response.valid) {
            this.$store.commit("setloggedIntoFacebook", true);
            this.facebookLoginLoading = false;
            // User is an SMM
            this.showCol4 = false;
            this.expandCol8 = true;
            this.getAgencyInfo();
          }
        })
        .catch((err) => {
          this.facebookLoginLoading = false;
          this.errorToken =
            "Your user token is invalid please login to Facebook.";
          this.$store.commit("setloggedIntoFacebook", false);
          this.overlay = false;
        });
    },
    //Logs user in with facebook SDK
    loginWithFacebook() {
      this.facebookLoginLoading = true;
      //incase user did cancel the login process
      this.cancelledLogin = false;
      FB.login(
        (response) => {
          if (response.authResponse) {
            this.userToken = response.authResponse.accessToken;
            this.extendUserFacebookToken();
          } else {
            this.cancelledLogin = true;
            this.overlay = false;
            // this.loading = false
          }
        },
        {
          scope:
            "read_insights, pages_show_list, ads_management, ads_read, page_events, pages_read_engagement, pages_read_user_content, public_profile, instagram_basic, instagram_manage_insights",
        }
      );
    },
    //Extends the userToken of client once logged in
    async extendUserFacebookToken() {
      const functions = getFunctions(firebaseApp, "europe-west2");
      const extendAccessToken = httpsCallable(functions, "extendAccessToken");

      extendAccessToken({
        token: this.userToken,
      }).then((result) => {
        this.updateUserFacebookToken(result.data.response);
      });
    },
    //Updates the user in firebase with the extended Token
    async updateUserFacebookToken(result) {
      const ref = doc(db, "users", this.currentUser.id);
      await updateDoc(ref, {
        facebookToken: result,
      });
      this.loading = false;

      const ref2 = doc(db, "users", this.currentUser.id);
      const userUpdated = await getDoc(ref2);

      this.$store.commit("setUser", userUpdated.data());
      this.currentUser = userUpdated.data();

      this.facebookLoginLoading = false;
      this.checkTokenValid(this.currentUser.facebookToken);
    },
    //Gets agency info if client has been cleared with facebook verification
    async getAgencyInfo() {
      try {
        const docRef = doc(db, "agencies", this.currentUser.agencyId);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          this.agencyProfile = docSnap.data();
          this.$store.commit("setAgency", this.agencyProfile);
          if (this.currentUser.resellerUid) {
            console.log(this.currentUser);
            this.getResellerAccount(this.currentUser.resellerUid);
          }
        } else {
          console.log("No such document!");
          this.overlay = false;
        }
      } catch (err) {
        console.log("getAgencyInfo err", err);
        this.overlay = false;
      }
    },
    //Gets agency info if client has been cleared with facebook verification
    async getResellerAccount(id) {
      try {
        const docRef = doc(db, "reseller", id);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          this.resellerAccount = docSnap.data();
          console.log("this.resellerAccount", this.resellerAccount);
          this.$store.commit("setResellerAccount", this.resellerAccount);
          if (
            this.resellerAccount.stripeAccountId != "" &&
            this.$store.state.resellerAccount.resellerUid != ""
          ) {
            console.log("Get Subscriptions");
            this.getResellerSubscriptions();
          }
          // this.getAgencySubscribers();
        } else {
          console.log("No such document!");
          this.overlay = false;
        }
      } catch (err) {
        console.log("getAgencyInfo err", err);
        this.overlay = false;
      }
    },
    async createResellerProfile() {
      try {
        const functions = getFunctions(firebaseApp, "europe-west2");
        const resellerAccounts = httpsCallable(functions, "resellerAccounts");

        resellerAccounts({
          type: "CreateResellerProfile",
          resellerUid: this.$store.state.user.id,
          resellerContactPersonName: this.currentUser.name,
          resellerContactPersonMobile: this.currentUser.mobile,
          resellerContactPersonEmail: this.currentUser.email,
          dateCreate: Date.now(),
          isActive: true,
          stripeAccountId: "",
        }).then((result) => {
          console.log(result);
          this.resellerAccount = result.data;
          this.$store.commit("setResellerAccount", this.resellerAccount);
          this.$emit("getcurrentuser");
          this.getResellerAccount(this.resellerAccount.uid);
        });
      } catch (e) {
        this.errorMessage = true;
        this.overlay = true;
        this.loading = false;
      }
    },
    createResellerConnectedAccount() {
      const functions = getFunctions(firebaseApp, "europe-west2");
      const resellerAccounts = httpsCallable(functions, "resellerAccounts");
      try {
        resellerAccounts({
          type: "CreateResellerAccount",
          country: "US",
          user: this.currentUser,
          agency: this.agencyProfile,
          resellerAccount: this.resellerAccount.uid,
        }).then((result) => {
          console.log(result);
          // if (
          //   result.data.stripeAccountId != "" ||
          //   result.data.stripeAccountId != null
          // ) {
          //   console.log(result.data.accountLinkUrl);
          // }
          // this.getResellerAccount(this.resellerAccount.uid);
        });
      } catch (e) {
        this.errorMessage = true;
        this.overlay = true;
        this.loading = false;
      }
    },
    toggleColumns() {
      this.showCol4 = !this.showCol4;
      this.expandCol8 = !this.expandCol8;
    },
    toggleMobileStats() {
      this.showStats = !this.showStats;
    },
    //Alert for the new subscription
    successAlert(message, typeOfAlert) {
      this.successResponse = message;
      this.alertType = typeOfAlert;
      this.alert = true;
      setTimeout(() => {
        this.alert = false;
      }, 5000);
      this.getAgencyActiveSubscriptions();
    },
    async getResellerSubscriptions() {
      const q = query(
        collection(db, "subscriptions"),
        where("agencyId", "==", this.$store.state.user.agencyId),
        where("resellerUid", "==", this.$store.state.user.resellerUid)
      );
      const querySnapshot = await getDocs(q);
      querySnapshot.forEach((doc) => {
        let subscription = doc.data();
        this.resellerActiveSubscriptions.push(subscription);
      });
      console.log("Active subscription", this.resellerActiveSubscriptions);
      this.overlay = false;
    },
    //Reseller-subscriptions page
    viewActiveSubscription() {
      this.$router.push({
        path: "/reseller-subscriptions",
      });
    },
  },
};
</script>
